import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
}));
const Chart = props => {
  const { data, labels, className, title, options, ...rest } = props;

  const classes = useStyles();

  const defaultOptions = {
    // responsive: true,
    // maintainAspectRatio: false,
    plugins: {
      // legend: {
      //   position: 'top',
      //   display: false,
      // },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || '';
            const value = context.parsed?.y ?? context.parsed;
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          // force integer labels only
          callback: function (value) {
            // value may be a string in some versions, coerce
            const v = Number(value);
            return Number.isInteger(v) ? v : null;
          },
          stepSize: 1,
        },
      },
      // x: {
      //   ticks: {
      //     autoSkip: true,
      //     maxRotation: 0,
      //     minRotation: 0,
      //   },
      // },
    },
  };

  const mergedOptions = options ? { ...defaultOptions, ...options } : defaultOptions;

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography variant='h6' style={{ textAlign: 'center' }}><strong>{title}</strong></Typography>
      <Bar
        data={data}
        options={mergedOptions}
        style={{ height: '100%' }}
        {...rest}
      />
    </div>
  );
};

Chart.propTypes = {
  className: PropTypes.string,
  data: PropTypes.any,
  labels: PropTypes.any,
  title: PropTypes.any,
  options: PropTypes.any
};

export default Chart;
